const en = {
  generalErrorMessage: {
    fieldIsRequired: "field is required",
  },
  //Login Process Messages
  authErrorMessage: {
    emailError: "The email field must be a valid email",
    passwordValid: "The password field must be at least 8 characters",
    validPassRegex:
      "Passwords must be at least 8 characters long, and contain at least 1 alphabet,1 uppercase, 1 numeric, and 1 special character",
    confirmPasswordValid: "The confirm password confirmation does not match",
    validCharacters:
      "The first name field may only contain alphabetic characters as well as spaces",
    minMust: "must be at least 3 characters",
  },
  //Create Company Process Messages
  companyErrorMessage: {
    phoneNumberValid: "The phone number field must be at least 10 characters",
  },
  email: "Email",
  password: "Password",
  firstName: "first name",
  lastName: "last name",
  phoneNumber: "phone number",
};

function checkErrors({
  field = {},
  name = "",
  validations = "",
  type = "string",
  event = null,
}) {
  return new Promise((resolve, reject) => {
    try {
      let rules =
        validations !== "" ? validations.split("|").map((x) => x.trim()) : "";
      let valid = true;
      let typeMsg = type === "number" ? "digits" : "characters";

      if (rules.length) {
        // REQUIRED
        if (rules.filter((x) => x.includes("required")).length) {
          if (event !== null) {
            if (
              event.target.value.trim() === "" ||
              event.target.value.trim() === null ||
              event.target.value === false
            ) {
              valid = false;
              document.querySelector(
                `.${field.selector}`
              ).innerText = `The ${name.toLowerCase()} ${
                en.generalErrorMessage.fieldIsRequired
              }`;
              setTimeout(() => {
                document.querySelector(`.${field.selector}`).innerText = "";
              }, 1500);
            }
          } else {
            if (
              field.value === "" ||
              field.value === null ||
              field.value === false
            ) {
              valid = false;
              document.querySelector(
                `.${field.selector}`
              ).innerText = `The ${name.toLowerCase()} ${
                en.generalErrorMessage.fieldIsRequired
              }`;
              setTimeout(() => {
                document.querySelector(`.${field.selector}`).innerText = "";
              }, 1500);
            }
          }
        }
        // REGEX
        if (rules.filter((x) => x.includes("regex")).length && valid) {
          let ind = rules.findIndex((x) => x.includes("regex"));
          if (ind !== -1) {
            let regex = rules[ind].split(":").pop().trim() || "";
            if (regex.length) {
              regex = new RegExp(regex);
              if (event !== null) {
                if (!regex.test(event.target.value.trim())) {
                  valid = false;
                  document.querySelector(`.${field.selector}`).innerText =
                    name == en.password && field.value.toString().length < 8
                      ? en.authErrorMessage.passwordValid
                      : name == en.password &&
                        field.value.toString().length >= 8
                      ? en.authErrorMessage.validPassRegex
                      : name == en.email
                      ? en.authErrorMessage.emailError
                      : name == en.firstName || name == en.lastName
                      ? en.authErrorMessage.validCharacters
                      : `The ${name.toLowerCase()} field must be a valid ${name.toLowerCase()}`;
                  setTimeout(() => {
                    document.querySelector(`.${field.selector}`).innerText = "";
                  }, 10000);
                }
              } else {
                if (!regex.test(field.value)) {
                  valid = false;
                  document.querySelector(`.${field.selector}`).innerText =
                    name == en.password && field.value.toString().length < 8
                      ? en.authErrorMessage.passwordValid
                      : name == en.password &&
                        field.value.toString().length >= 8
                      ? en.authErrorMessage.validPassRegex
                      : name == en.email
                      ? en.authErrorMessage.emailError
                      : name == en.firstName || name == en.lastName
                      ? en.authErrorMessage.validCharacters
                      : `The ${name.toLowerCase()} field must be a valid ${name.toLowerCase()}`;
                  setTimeout(() => {
                    document.querySelector(`.${field.selector}`).innerText = "";
                  }, 10000);
                }
              }
            } else {
              console.warn("No regex found!");
            }
          }
        }

        // MIN
        if (rules.filter((x) => x.includes("min")).length && valid) {
          let ind = rules.findIndex((x) => x.includes("min"));
          if (ind !== -1) {
            let min = Number(rules[ind].split(":").pop());
            if (event !== null) {
              if (event.target.value.trim().toString().length < min) {
                valid = false;
                document.querySelector(`.${field.selector}`).innerText =
                  name === en.phoneNumber
                    ? en.companyErrorMessage.phoneNumberValid
                    : `The ${name.toLowerCase()} field must be at least ${min} ${typeMsg}`;
                setTimeout(() => {
                  document.querySelector(`.${field.selector}`).innerText = "";
                }, 10000);
              }
            } else {
              if (field.value.toString().length < min) {
                valid = false;
                document.querySelector(`.${field.selector}`).innerText =
                  name === en.phoneNumber
                    ? en.companyErrorMessage.phoneNumberValid
                    : `The ${name.toLowerCase()} field must be at least ${min} ${typeMsg}`;
                setTimeout(() => {
                  document.querySelector(`.${field.selector}`).innerText = "";
                }, 10000);
              }
            }
          }
        }
        // MAX
        if (rules.filter((x) => x.includes("max")).length && valid) {
          let ind = rules.findIndex((x) => x.includes("max"));
          if (ind !== -1) {
            let max = Number(rules[ind].split(":").pop());
            if (event !== null) {
              if (event.target.value.trim().toString().length > max) {
                valid = false;
                document.querySelector(
                  `.${field.selector}`
                ).innerText = `${name} must be less than ${max} ${typeMsg}`;
                setTimeout(() => {
                  document.querySelector(`.${field.selector}`).innerText = "";
                }, 10000);
              }
            } else {
              if (field.value.toString().length > max) {
                valid = false;
                document.querySelector(
                  `.${field.selector}`
                ).innerText = `${name} must be less than ${max} ${typeMsg}`;
                setTimeout(() => {
                  document.querySelector(`.${field.selector}`).innerText = "";
                }, 10000);
              }
            }
          }
        }
        // CONFIRMATION
        if (rules.filter((x) => x.includes("confirmation")).length && valid) {
          let ind = rules.findIndex((x) => x.includes("confirmation"));
          if (ind !== -1) {
            let confirm = rules[ind].split(":").pop().trim() || "";
            if (confirm.length) {
              if (event !== null) {
                if (event.target.value.trim() !== confirm) {
                  valid = false;
                  document.querySelector(
                    `.${field.selector}`
                  ).innerText = `${en.authErrorMessage.confirmPasswordValid}`;
                  setTimeout(() => {
                    document.querySelector(`.${field.selector}`).innerText = "";
                  }, 10000);
                }
              } else {
                if (field.value !== confirm) {
                  valid = false;
                  document.querySelector(
                    `.${field.selector}`
                  ).innerText = `${en.authErrorMessage.confirmPasswordValid}`;
                  setTimeout(() => {
                    document.querySelector(`.${field.selector}`).innerText = "";
                  }, 10000);
                }
              }
            } else {
              console.warn("No confirmation field found!");
            }
          }
        }

        // NO ERRORS
        if (valid) {
          document.querySelector(`.${field.selector}`).innerText = "";
        }
      }
      resolve(valid);
    } catch (error) {
      reject(error);
    }
  });
}

function checkAllFields(formData) {
  return new Promise((resolve, reject) => {
    try {
      let valid = true;
      Object.keys(formData).forEach((key) => {
        checkErrors({
          field: formData[key],
          name: formData[key].name,
          validations: formData[key].rules,
          type: formData[key].type,
        })
          .then((res) => {
            if (res === false) {
              valid = false;
            }
          })
          .catch((error) => {
            console.error("ERROR in check validation: ", error);
          });
      });
      setTimeout(() => {
        resolve(valid);
      });
    } catch (error) {
      reject(error);
    }
  });
}
